import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output
} from '@angular/core';
import type { IReinsurance } from '../../../_interfaces/reinsurrance.interface';

import { BrandThemesEnum, ThemesEnum } from '../../../_enums/themes.enum';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdBannerComponent } from '../../medias/banner/banner.component';
import { SdIconComponent } from '../../icons/icon/icon.component';
import { SdLinkComponent } from '../../links/link/link.component';
import { SdTitleComponent } from '../../title/title.component';
import { ThemesTextEnum } from '../../../_enums/themes-text.enum';
import { ILink } from '../../../_interfaces/link.interface';

@Component({
  selector: 'sd-reinsurance',
  templateUrl: './reinsurance.component.html',
  standalone: true,
  imports: [
    SdTitleComponent,
    SdBannerComponent,
    SdIconComponent,
    SdLinkComponent
  ]
})
export class SdReinsuranceComponent implements OnInit {
  @Input()
  data: IReinsurance;

  @Input()
  isBrand = false;

  /**
   * Allow to define if the text is aligned to the left or the right, or even centered
   * * @param {string} left | right | center
   */
  @Input()
  textConfig: PositionEnum = PositionEnum.center;

  @Input()
  textThemesConfig: ThemesTextEnum = ThemesTextEnum.dark;

  @Input()
  hasSubline = true;

  @Input()
  titleLevel: number;

  @Output()
  clickedReinsurance = new EventEmitter<string>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.textConfig
        ? 'is-' + this.textConfig + '-aligned'
        : 'is-' + PositionEnum.center + '-aligned',
      this.textThemesConfig
        ? 'is-theme-' + this.textThemesConfig
        : 'is-theme-' + ThemesTextEnum.dark,
      this.isPictoLinkDesc ? 'is-picto-link-desc' : '',
      this.hasSubline ? 'has-subline' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  isPictoLinkDesc!: boolean;
  brandThemesEnum = BrandThemesEnum;
  themesEnum = ThemesEnum;

  ngOnInit(): void {
    this.isPictoLinkDesc =
      this.data?.icons?.length === 1 &&
      this.data?.subtitle &&
      this.data?.icons[0].icon &&
      !!this.data?.icons[0].link;
  }

  onClick(event: ILink): void {
    this.clickedReinsurance.emit(event.linkName);
  }
}
